module.exports = __webpack_public_path__ + "img/cenprot-mobile.12a862cf.jpg";